var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_4714)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0099 35.75C25.3799 35.75 24.7499 35.54 24.2599 35.12L22.6799 33.76C22.5199 33.62 22.1199 33.48 21.9099 33.48H20.1799C18.6999 33.48 17.4999 32.28 17.4999 30.8V29.09C17.4999 28.88 17.3599 28.49 17.2199 28.33L15.8699 26.74C15.0499 25.77 15.0499 24.24 15.8699 23.27L17.2199 21.68C17.3599 21.52 17.4999 21.13 17.4999 20.92V19.21C17.4999 17.73 18.6999 16.53 20.1799 16.53H21.9099C22.1199 16.53 22.5199 16.38 22.6799 16.25L24.2599 14.89C25.2399 14.05 26.7699 14.05 27.7499 14.89L29.3299 16.25C29.4899 16.39 29.8899 16.53 30.0999 16.53H31.7999C33.2799 16.53 34.4799 17.73 34.4799 19.21V20.91C34.4799 21.12 34.6299 21.52 34.7699 21.68L36.1199 23.26C36.9599 24.24 36.9599 25.77 36.1199 26.75L34.7699 28.33C34.6299 28.49 34.4899 28.89 34.4899 29.1V30.8C34.4899 32.28 33.2899 33.48 31.8099 33.48H30.1099C29.8999 33.48 29.4999 33.63 29.3399 33.76L27.7599 35.12C27.2599 35.54 26.6299 35.75 26.0099 35.75ZM20.1799 18.02C19.5299 18.02 18.9999 18.5499 18.9999 19.1999V20.91C18.9999 21.48 18.7299 22.21 18.3699 22.64L17.0199 24.23C16.6699 24.64 16.6699 25.35 17.0199 25.76L18.3699 27.35C18.7399 27.79 19.0099 28.52 19.0099 29.08V30.79C19.0099 31.44 19.5399 31.97 20.1899 31.97H21.9199C22.4999 31.97 23.2299 32.24 23.6699 32.62L25.2499 33.98C25.6599 34.33 26.3799 34.33 26.7899 33.98L28.3699 32.62C28.8099 32.25 29.5399 31.97 30.1199 31.97H31.8199C32.4699 31.97 32.9999 31.44 32.9999 30.79V29.09C32.9999 28.51 33.2699 27.78 33.6499 27.34L34.9999 25.76C35.3499 25.35 35.3499 24.63 34.9999 24.22L33.6499 22.64C33.2799 22.2 32.9999 21.47 32.9999 20.89V19.1899C32.9999 18.5399 32.4699 18.01 31.8199 18.01H30.1199C29.5499 18.01 28.8099 17.74 28.3699 17.36L26.7899 16C26.3799 15.65 25.6599 15.65 25.2499 16L23.6699 17.36C23.2299 17.73 22.4999 18.01 21.9199 18.01H20.1799V18.02Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 29.9698H26.2198C25.7998 29.9698 25.1697 29.8398 24.7997 29.4698L23.4198 28.4099L24.3398 27.2198L25.7898 28.3398C25.8898 28.4098 26.0698 28.4598 26.2198 28.4598H27.9998C28.2398 28.4598 28.5297 28.2499 28.5797 28.0399L29.7198 24.5698C29.7498 24.4798 29.7497 24.4199 29.7397 24.3999C29.7197 24.3699 29.6497 24.3398 29.5497 24.3398H27.6797C27.3197 24.3398 26.9898 24.1899 26.7498 23.9199C26.5198 23.6499 26.4097 23.2899 26.4597 22.9199L26.6998 21.4099C26.7198 21.3299 26.6598 21.2298 26.5998 21.2098C26.5398 21.1998 26.4498 21.2199 26.4198 21.2499L24.5098 24.0898L23.2598 23.2499L25.1797 20.3999C25.5797 19.7999 26.4198 19.5399 27.0998 19.7899C27.8598 20.0399 28.3497 20.8999 28.1797 21.6799L27.9998 22.8198H29.5497C30.1397 22.8198 30.6598 23.0699 30.9698 23.5099C31.2698 23.9399 31.3397 24.4999 31.1497 25.0299L30.0298 28.4299C29.8198 29.2899 28.9298 29.9698 27.9998 29.9698Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9002 29.4601H22.4302C20.9602 29.4601 20.7402 28.4301 20.7402 27.8201V23.2401C20.7402 22.6301 20.9602 21.6001 22.4302 21.6001H22.9002C24.3702 21.6001 24.5902 22.6301 24.5902 23.2401V27.8201C24.5902 28.4301 24.3702 29.4601 22.9002 29.4601ZM22.2603 27.9501C22.3003 27.9601 22.3602 27.9601 22.4402 27.9601H22.9102C22.9902 27.9601 23.0502 27.9601 23.0902 27.9501C23.0902 27.9201 23.1003 27.8801 23.1003 27.8201V23.2401C23.1003 23.1801 23.1002 23.1401 23.0902 23.1101C23.0502 23.1001 22.9902 23.1001 22.9102 23.1001H22.4402C22.3602 23.1001 22.3003 23.1001 22.2603 23.1101C22.2603 23.1401 22.2502 23.1801 22.2502 23.2401V27.8201C22.2502 27.8801 22.2503 27.9201 22.2603 27.9501Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_4714",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_4714"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_4714",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.19cde6884fa66120afe2e728b08d3ab3.svg";
export { ForwardRef as ReactComponent };